package co.uk.paxes.pinpoint.model

import kotlinx.serialization.Serializable

@Serializable
data class GameConfig(
    val players: List<Player>,
    val startingPlayerId: String? = null,
    val boardSeed: Long? = null,
    val isNetworkClient: Boolean = false,
    val existingBoard: Board? = null  // For game restore - use existing board instead of creating new one
)
